import {Sound} from '@pixi/sound';
import {Assets} from 'pixi.js';
import {useEffect, useRef} from 'react';
import {BANKED_RING} from '../assetManifest';
import {useObjectivesStats} from '../hooks/useObjectivesComplete';

export function BankObjectiveSoundEffect() {
    const {completeObjectivesCount} = useObjectivesStats();
    const previousCount = useRef<number>(completeObjectivesCount);

    useEffect(() => {
        if (previousCount.current != undefined && (previousCount.current < completeObjectivesCount)) {
            void Assets.get<Sound>(BANKED_RING).play();
            previousCount.current = completeObjectivesCount;
        }
    }, [completeObjectivesCount, previousCount.current]);

    return null;
}
